import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { ForecastState, ForecastStore } from './forecast.store';

@Injectable({ providedIn: 'root' })
export class ForecastQuery extends Query<ForecastState> {
  protected store: ForecastStore;

  constructor() {
    const store = inject(ForecastStore);

    super(store);

    this.store = store;
  }
}
